export default __webpack_public_path__ + "assets/Tenure.a94d.svg";